import { Link } from "react-router-dom";
import { localePath } from "@/config/site";
import { useI18n } from "@/i18n/I18nContext";
import { TextPageLayout } from "@/pages/components/TextPageLayout";
import { DocumentHead } from "@/seo/DocumentHead";

export function NotFoundPage() {
  const { locale } = useI18n();
  const home = localePath(locale);

  return (
    <TextPageLayout title="Page Not Found">
      <DocumentHead
        title="Page Not Found — WasOK"
        description="The page you’re looking for doesn’t exist on WasOK."
        noIndex
      />
      <p className="mb-6 text-gray-700">
        The page you&apos;re looking for doesn&apos;t exist or may have been
        moved.
      </p>

      <div className="mt-12 rounded-3xl bg-gradient-to-br from-[#4CAF50] to-[#45a049] p-8 text-white">
        <h2 className="mb-3 text-2xl">Back to WasOK</h2>
        <p className="mb-6">
          Return to the homepage to learn more about the app.
        </p>
        <Link
          to={home}
          className="inline-block rounded-xl bg-white px-8 py-3 text-[#4CAF50] transition-colors duration-200 hover:bg-gray-100"
        >
          Go to Homepage
        </Link>
      </div>
    </TextPageLayout>
  );
}
